import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificDataComponent } from '../../abstract-specific-data.component';

@Component({
    selector: 'app-specific-data-conf19',
    templateUrl: './specific-data-conf19.component.html',
    styleUrls: ['../specific-data-conf.common.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpecificDataConf19Component extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'specific-data-conf19';
  }
}
